import { Box, IconButton, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Table, TableRow, ButtonContainer, TableHead, TableColumn } from "../style";
import { DeleteForever as DeleteForeverIcon, Edit as EditIcon } from '@material-ui/icons'
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import styled from "styled-components";
import { Icon } from "../../../components/common";

const DroppableContainer = styled.div``

const Wrapper = styled.div`
    ${props => props.index % 2 === 0 && `
        background-color: rgba(0,0,0,0.03)
    `}
`

export const LogisticsIntegrationTable = (props) => {

    const { selectPlatform, deliveryPlatform, onChangePlatformPriority } = props;

    const [deliveryPlatforms, setDeliveryPlatforms] = useState(deliveryPlatform)

    const handleCategoryDrag = (result) => {
        if (result.destination && result.destination.index) {
            const newCategories = [...deliveryPlatforms]
            const item = newCategories.splice(result.source.index, 1)[0]
            newCategories.splice(result.destination.index, 0, item)
            for (let i = 0; i < newCategories.length; i++) {
                newCategories[i].priority = i + 1;
            }
            setDeliveryPlatforms(newCategories);
            onChangePlatformPriority(newCategories);
        }
    }

    useEffect(() => {
        setDeliveryPlatforms(deliveryPlatform)
    }, [deliveryPlatform])

    return (
        <>
            <DragDropContext onDragEnd={handleCategoryDrag}>
                <Table>
                    <TableHead>
                        <TableColumn width="60px">
                            Prioridade
                        </TableColumn>
                        <TableColumn width="14.28%">
                            Plataforma
                        </TableColumn>
                        <TableColumn width="20.28%">
                            Chave de integração
                        </TableColumn>
                        <TableColumn width="9.28%">
                            Entregador
                        </TableColumn>
                        <TableColumn width="11.28%">
                            Calcular taxa de entrega
                        </TableColumn>
                        <TableColumn width="6.28%">
                            Seguro
                        </TableColumn>
                        <TableColumn width="14.28%">
                            Contatar entregador manualmente
                        </TableColumn>
                        <TableColumn width="88px">
                        </TableColumn>
                    </TableHead>


                    {deliveryPlatforms && deliveryPlatforms.length ? (
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <DroppableContainer
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {
                                        deliveryPlatforms.map((li, index) => {
                                            return (
                                                <Draggable type="detailItem" key={`detailItem${index}`} draggableId={`detailItem${index}`} index={index}>
                                                    {(provided, snapshot) => (
                                                        <Wrapper index={index} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>

                                                            <TableRow key={index} gap>
                                                                <TableColumn width="60px">
                                                                    <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        <Icon name="drag" />
                                                                        <Typography>{li.priority}</Typography>
                                                                    </Box>
                                                                </TableColumn>
                                                                <TableColumn width="14.28%">
                                                                    {
                                                                        selectPlatform.find((platform) => li.platform === platform.value)?.label
                                                                    }
                                                                </TableColumn>
                                                                <TableColumn width="20.28%">
                                                                    {li.integrationKey}
                                                                </TableColumn>
                                                                <TableColumn width="9.28%">
                                                                    {li.callDeliveryman ? 'Sim' : 'Não'}
                                                                </TableColumn>
                                                                <TableColumn width="11.28%">
                                                                    {li.deliveryTaxCalc ? 'Sim' : 'Não'}
                                                                </TableColumn>
                                                                <TableColumn width="6.28%">
                                                                    {li.security ? 'Sim' : 'Não'}
                                                                </TableColumn>
                                                                <TableColumn width="11.28%">
                                                                    {li.callDeliverymanManually ? 'Sim' : 'Não'}
                                                                </TableColumn>
                                                                <TableColumn width="88px">
                                                                    <ButtonContainer>
                                                                        <IconButton
                                                                            onClick={() => props.onEdit(li)}
                                                                            color="primary"
                                                                            style={{ padding: 6 }}>
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            onClick={() => props.onDelete(li)}
                                                                            color="secondary"
                                                                            style={{ padding: 6 }}>
                                                                            <DeleteForeverIcon />
                                                                        </IconButton>
                                                                    </ButtonContainer>
                                                                </TableColumn>
                                                            </TableRow>
                                                        </Wrapper>

                                                    )}
                                                </Draggable>
                                            )
                                        })
                                    }
                                </DroppableContainer>
                            )
                            }
                        </Droppable>
                    ) :
                        (<i>Sem integrações cadastradas</i>)}


                </Table>
            </DragDropContext>
        </>
    )
}
